<template>
<div id="app">
<v-app>
<NavComponent></NavComponent>

  <!-- 左メニュー -->
  <v-navigation-drawer app clipped
    v-if="not_login_page"
    permanent
    expand-on-hover
    class="pa-0 text-left"
    mini-variant
    mini-variant-width="56"
    width="180"
  >

    <v-divider></v-divider>

    <v-list nav dense class="mt-6">
      <v-list-item-group
        active-class="change-green-icon"
        color="green"
      >
            <!-- ■来院管理 -->
            <v-list-item link to="/reservecalendar" color="mygreen" class="menu1">
                <template v-slot:default="{ active }">
                    <v-list-item-icon class="mr-4">
                        <img v-show="active" class="img" src="/img/icon_raiin_green.svg" style="" />
                        <img v-show="!active" class="img" src="/img/icon_raiin.svg" style="" />
                    </v-list-item-icon>
                    <v-list-item-title>来院管理</v-list-item-title>
                </template>
            </v-list-item>
            <!-- ■勤怠管理 -->
            <v-list-item link to="/kintai/" color="mygreen">
                <template v-slot:default="{ active }">
                    <v-list-item-icon class="mr-4">
                        <img v-show="active" class="img" src="/img/icon_kintai_green.svg" style="" />
                        <img v-show="!active" class="img" src="/img/icon_kintai.svg" style="" />
                    </v-list-item-icon>
                    <v-list-item-title>勤怠管理</v-list-item-title>
                </template>
            </v-list-item>
            <!-- ■患者管理 -->
            <v-list-item link to="/patientlist">
                <template v-slot:default="{ active }">
                    <v-list-item-icon class="mr-4">
                        <img v-show="active" class="img" src="/img/icon_kanjya_green.svg" style="" />
                        <img v-show="!active" class="img" src="/img/icon_kanjya.svg" style="" />
                    </v-list-item-icon>
                    <v-list-item-title>患者管理</v-list-item-title>
                </template>
            </v-list-item>
            <!-- ■メール管理 -->
            <v-list-item link to="/mail">
                <template v-slot:default="{ active }">
                    <v-list-item-icon class="mr-4">
                        <img v-show="active" class="img" src="/img/icon_mail_green.svg" style="" />
                        <img v-show="!active" class="img" src="/img/icon_mail.svg" style="" />
                    </v-list-item-icon>
                    <v-list-item-title>メール管理</v-list-item-title>
                </template>
            </v-list-item>
            <!-- ■テンプレート管理 -->
            <v-list-item link to="/template">
                <template v-slot:default="{ active }">
                    <v-list-item-icon class="mr-4">
                        <img v-show="active" class="img" src="/img/icon_template_green.svg" style="" />
                        <img v-show="!active" class="img" src="/img/icon_template.svg" style="" />
                    </v-list-item-icon>
                    <v-list-item-title>テンプレート管理</v-list-item-title>
                </template>
            </v-list-item>
            <!-- ■スタッフ管理 -->
            <v-list-item link to="/stafflist">
                <template v-slot:default="{ active }">
                    <v-list-item-icon class="mr-4">
                        <img v-show="active" class="img" src="/img/icon_staff_green.svg" style="" />
                        <img v-show="!active" class="img" src="/img/icon_staff.svg" style="" />
                    </v-list-item-icon>
                    <v-list-item-title>スタッフ管理</v-list-item-title>
                </template>
            </v-list-item>
            <!-- ■シフト管理 -->
            <v-list-item link to="/shift">
                <template v-slot:default="{ active }">
                    <v-list-item-icon class="mr-4">
                        <img v-show="active" class="img" src="/img/icon_shift_green.svg" style="" />
                        <img v-show="!active" class="img" src="/img/icon_shift.svg" style="" />
                    </v-list-item-icon>
                    <v-list-item-title>シフト管理</v-list-item-title>
                </template>
            </v-list-item>
            <!-- ■休暇管理 -->
            <v-list-item link to="/kyuka">
                <template v-slot:default="{ active }">
                    <v-list-item-icon class="mr-4">
                        <img v-show="active" class="img" src="/img/icon_kyuka_green.svg" style="" />
                        <img v-show="!active" class="img" src="/img/icon_kyuka.svg" style="" />
                    </v-list-item-icon>
                    <v-list-item-title>休暇管理</v-list-item-title>
                </template>
            </v-list-item>
            <!-- ■各種設定 -->
            <v-list-item v-if="is_admin" link to="/settings">
                <template v-slot:default="{ active }">
                    <v-list-item-icon class="mr-4">
                        <img v-show="active" class="img" src="/img/icon_setting_green.svg" style="" />
                        <img v-show="!active" class="img" src="/img/icon_setting.svg" style="" />
                    </v-list-item-icon>
                    <v-list-item-title>各種設定</v-list-item-title>
                </template>
            </v-list-item>

      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>

  <!-- メイン -->
  <v-main class="grey lighten-3">
  <v-container fluid class="">
      <router-view ref="view"/>
  </v-container>
  <v-spacer></v-spacer>
  </v-main>



<!-- フッター -->
<v-footer app clipped-left>
<div class="">

<v-row justify="space-between">
    <v-col cols="12" class="text-left">
      <router-view name="footer" />
    </v-col>
</v-row>
</div>
</v-footer>


</v-app>
</div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import ReconnectingWebSocket from 'reconnecting-websocket';
import mycolor from '@/mycolor.js';
import axios from 'axios';
import myMixin from '@/mixin.js';
import {mapGetters} from 'vuex';
import NavComponent from '@/components/NavComponent.vue';
import DialogSyochinaiyou from '@/components/DialogSyochinaiyou.vue';
/* eslint-disable */

export default{
    name: 'App',
    mixins: [myMixin],
    components:{
        NavComponent
    },



  data(){  // datas
    return {
        doctors: [],
        connection: null,
    }
  },
  computed: {
      ...mapGetters(['user', 'is_admin']),
      not_login_page() {
          return this.$route.name!=='login';
      },
  },
  wathch: {
  },
  async mounted(){


/*

addEventListener(type: 'open' | 'close' | 'message' | 'error', listener: EventListener)

        rws.addEventListener('open', () => {
            rws.send('hello!');
        });

        this.connection.onmessage = function(event) {
          console.log(event);
        }


        this.connection.onopen = function(event) {
          console.log(event)
          console.log("Successfully connected to the echo websocket server...")
          this.sendMessage();

        }

        // websocketでエラーが発生した時
        this.connection.onerror = function(event) {
          console.log("### websocket.onerror()");
          console.log(event);
        };

        // websocketをクローズした時
        this.connection.onclose = function(event) {
          console.log("### websocket.onclose()");
          console.log(event);
        };
*/




  },
  async created(){
      console.log('%c created: App.vue', mycolor.created);

      const options = {
          debug: true,
      };

      this.connection = new ReconnectingWebSocket(this.$websocket, [], options);

      this.connection.addEventListener('open', () => {
          this.connection.send('hello!');
      });

      this.connection.addEventListener('message', (e) => {
          console.log('%c %s', mycolor.strong, 'websocket_message: '+e.data);
          console.log(e);
          console.log(this.$route.name);
          console.log(this.$refs);
          console.log(this.$refs.view);
          console.groupEnd();
          this.getNotice(e);  // 通知取得

          // todo: その他メッセージに応じた処理分岐
          if( ['insert_kyuka', 'kyuka_delete'].includes(e.data) ){
                if( ['kyuka'].includes(this.$route.name) ){
                  this.$refs.view.getList();
                }
          }


          if( e.data.indexOf('yoyaku ')!==-1 || e.data.indexOf('yoyaku_update ')!==-1 ){  // スペースの後に予約日時が続くstring
                // 音声通知
                let websocket_message = e.data.split(' ')[1];
                console.log('websocket_message: ', websocket_message);
                if(websocket_message){
                    let msg = new SpeechSynthesisUtterance();
                    msg.text = websocket_message;
                    window.speechSynthesis.speak(msg);
                }

          }
          if( e.data.indexOf('yoyaku')!==-1 ){
                if( ['reservecalendar', 'reservecalendar_specific'].includes(this.$route.name) ){
                    this.$refs.view.getYoyaku();
                }
          }

          // 勤怠打刻
          if( e.data.indexOf('kintai_dakoku')!==-1 ){
              console.log('kintai_dakoku', mycolor.strong);
              // let msg = new SpeechSynthesisUtterance();
              // msg.text = '勤怠打刻しました';
              // window.speechSynthesis.speak(msg);
              this.$refs.view.KintaiDakoku();
          }


      });

  },
  watch:{
  },
  methods: {
       sendMessage: function(message) {
          //console.log(this.connection);
          //this.connection.send(message);
          this.connection.send(this.username);
        },
  }, // methods
}
</script>

<style lang="scss">
/* ここに書くのはグローバル設定 */
#app {
  /* todo: 日本語font決める */
  font-family: "Helvetica Neue",
    Arial,
    "Hiragino Kaku Gothic ProN",
    "Hiragino Sans",
    "BIZ UDPGothic",
    Meiryo,
    sans-serif;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

header{
    height: 60px !important;
}

nav{
    top: 50px !important;
    max-height: none !important;
}
.v-toolbar__content{
}
.v-main{
}
.colorbox{
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 10px;
    margin-right: 10px;
}
.doctorname{
    display: inline-block;
    margin-right: 15px;
}
.err_msg{
    color: #f55d5d;
}
.v-date-picker-table.v-date-picker-table--date > table > tbody tr td:nth-child(7) .v-btn__content {
    color:blue
}
.v-date-picker-table.v-date-picker-table--date > table > tbody tr td:nth-child(1) .v-btn__content {
    color:red
}
/* メインのグリーン */
.v-application .mygreen {
    background-color: #8CC11E !important;
    border-color: #8CC11E !important;
}
.theme--light.v-app-bar.v-toolbar.v-sheet{
    background: #fff !important;
}

.v-footer{
    padding: 12px !important;
    max-width: 1256px;
    margin-left:350px;
}
.v-input__slot{
    min-height: 40px !important;
}

/* 左メニューのbackground */
.theme--light.v-list-item--active:hover::before, .theme--light.v-list-item--active::before{
}
.change-green-icon{
    /* background: deepskyblue; */
}

.mybadge .v-badge__wrapper{
    top: 8px;
    left: -8px;
}
.bell:hover{
    cursor:pointer;
}
.myleft{
    text-align: left;
}
.border_bottom{
    border-bottom: solid #0000001f 1px;
    width: 94%;
    margin: auto;
}
.v-list-item.border_bottom{
    padding: 0 !important;
}
.border_bottom:last-child {
    border: none;
}
.user_btn{
    background: none !important;
    box-shadow: none !important;
    padding-right: 46px !important;
}
.oshirase .v-list-item__title{
    font-size: 0.9rem;
    min-width:320px;
}
.kidoku{
    color: #5C99F0;
    cursor: pointer;
    margin: 10px 0px;
}

/* スクロールバー */
::-webkit-scrollbar-thumb {
    /* background: #96a774; */
    background: #858585;
    border-radius: 6px;
}
::-webkit-scrollbar-track {
    background: rgb(200 200 200 / 52%);
}
::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

@media (min-width: 1264px){
    .container {
        max-width: 1280px !important;
    }
}
</style>
